import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import API from '../api';

const ProtectedRoute = ({ children }) => {
  const [isAuthChecked, setIsAuthChecked] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('token'));
  const location = useLocation();

  useEffect(() => {
    const verifyToken = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        setIsAuthenticated(false);
        setIsAuthChecked(true);
        return;
      }

      try {
        await API.get('/auth/verify');
        setIsAuthenticated(true);
      } catch {
        localStorage.removeItem('token');
        localStorage.removeItem('employee');
        setIsAuthenticated(false);
      } finally {
        setIsAuthChecked(true);
      }
    };

    verifyToken();
  }, []);

  if (!isAuthChecked) {
    return (
      <div className="flex items-center justify-center min-h-screen text-lg font-semibold">
        Checking authentication...
      </div>
    );
  }

  return isAuthenticated ? children : <Navigate to="/login" replace state={{ from: location }} />;
};

export default ProtectedRoute;
